module.exports = __webpack_public_path__ + "files/90a203bc1ce2216978a25d776cfa1d05.png";